import { render } from "./QuizTexteATrous.vue?vue&type=template&id=0c632c90&scoped=true"
import script from "./QuizTexteATrous.vue?vue&type=script&lang=js"
export * from "./QuizTexteATrous.vue?vue&type=script&lang=js"

import "./QuizTexteATrous.vue?vue&type=style&index=0&id=0c632c90&scoped=true&lang=css"

import exportComponent from "C:\\projets\\salon-metiers-2026\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c632c90"]])

export default __exports__